

export default {
  SET_ITEMS(state, payload) {
    state.cities = payload
  },

  ADD_ITEM(state, payload) {
    state.cities.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.cities.findIndex((p) => p.id == payload.id)
      Object.assign(state.cities[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.cities.findIndex((p) => p.id == itemId)
      state.cities.splice(ItemIndex, 1)
  }
}
